import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgTextB = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M19.521 12.655a4.813 4.813 0 0 0-3.334-8.28H8.75a.875.875 0 0 0-.875.875v16.625a.875.875 0 0 0 .875.875h8.75a5.25 5.25 0 0 0 2.021-10.095Zm-9.896-6.53h6.563a3.062 3.062 0 0 1 0 6.125H9.625V6.125ZM17.5 21H9.625v-7H17.5a3.5 3.5 0 1 1 0 7Z" />
  </svg>
);
export default SvgTextB;
